import React from 'react';
import cx from 'classnames';

interface IProps {
  children?: any;
  className?: string;
  type?: 'button' | 'reset' | 'submit' | undefined;
  variant?: 'primary' | 'default' | undefined;
  sticky?: 'lg' | 'sm' | 'all' | undefined;
  onClick?: (e: any) => void;
  style?: any;
  [k: string]: any;
}

const Button = ({ className, variant, sticky, type, onClick, children, style, ...props }: IProps) => (
  <button
    className={cx('btn', className, variant && `btn-${variant}`, sticky && `btn-sticky-${sticky}`)}
    type={type}
    onClick={onClick}
    style={{ ...style }}
    {...props}
  >
    {children}
  </button>
);

Button.defaultProps = {
  className: undefined,
  children: undefined,
  variant: undefined,
  sticky: undefined,
  onClick: undefined,
  type: 'button',
  style: {},
};

export { Button };
